import(/* webpackMode: "eager" */ "/export/volumes/higuard/frontend/src/app/layout.tsx");
